var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Profile_Icon_","data-name":"Profile Icon ","transform":"translate(-9.789 -12.712)"},[React.createElement("path",{"id":"Path_174","data-name":"Path 174","d":"M833.737,262.022c-.895-3.869-1.816-7.341-11.095-7.235l-.113,0c-9.148-.069-10.066,3.387-10.956,7.236-.895,3.869,1.491,3.115,1.491,3.115h7.815l0,.01,1.387-.009,1.164.007-.006-.013h8.822S834.632,265.891,833.737,262.022Z","transform":"translate(-801.584 -230.349)","fill":"#242424","key":0}),React.createElement("circle",{"id":"Ellipse_230","data-name":"Ellipse 230","cx":"5.384","cy":"5.384","r":"5.384","transform":"translate(15.699 12.712)","fill":"#242424","key":1})]));
}

Profile.defaultProps = {"width":"22.565","height":"22.14","viewBox":"0 0 22.565 22.14"};

module.exports = Profile;

Profile.default = Profile;
